import { render, staticRenderFns } from "./workerOrder - 副本.vue?vue&type=template&id=789a8006"
import script from "./workerOrder - 副本.vue?vue&type=script&lang=js"
export * from "./workerOrder - 副本.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports